if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    let packagePage = document.querySelector('body.north-carolina-hotel-deals')

    if(!packagePage){
        $( ".form-module-wrapper:not(.footer) .form-module__confirmation, .form-module-wrapper:not(.footer) form").wrapAll( "<div class='form-module-wrapper__container container animate-fade top'></div>" );
    }
    
    // setTimeout(() => {
    //     $('.form-module-wrapper__container').prepend('<div class="info-form"><div class="info-form__container"><p class="location">1900 Reynolda Road  Winston-Salem, NC 27106</p><p class="phone">(800) 472-9596</p><div/><div/>');
    // }, 300);

    $('.timeline__slider').slick({
        arrows: true,
        dots: false,
        variableWidth: true,
        infinite: false,
        speed: 600,
        centerMode:true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    variableWidth: false,
                    centerMode: false
                }
            }
        ]
    });

    let pointsMap = document.querySelectorAll('.location-quad__map--point img');
    if(pointsMap){
        pointsMap.forEach( (point, index) => {
            const srcImage = point.dataset.url;
            const dataBg = point.dataset.hover;
            point.addEventListener('mouseenter', () =>{
                point.src = dataBg;
            });

            point.addEventListener('mouseleave', () =>{
                if(!point.classList.contains('active')){
                    point.src = srcImage;
                }
            })

            point.addEventListener('click', (e)=>{
                let pointActive = document.querySelector('.location-quad__map--point img.active');

                if(pointActive !== null) {
                    pointActive.classList.remove('active');
                    pointActive.src = pointActive.dataset.url;
                }

				point.classList.add('active');
                point.src = dataBg;
                $('.location-quad__slider').slick('slickGoTo', e.target.dataset.index);
            });
        });
    }

    $('.location-quad__slider .slick-next').click(function(){
        document.querySelectorAll('.location-quad__map--point img').forEach( b => {
            const srcImage2 = b.dataset.url;
            b.classList.remove('active');
            b.src = srcImage2;
        });
        const index = $(".location-quad__slider .slick-current").data('slick-index');
        let srcNew = $('.location-quad__map--point .slick-position-'+index).data('hover');
        $('.location-quad__map--point .slick-position-'+index).attr('src',srcNew);
        $('.location-quad__map--point .slick-position-'+index).addClass('active');
    });

    $('.location-quad__slider .slick-prev').click(function(){
        document.querySelectorAll('.location-quad__map--point img').forEach( b => {
            const srcImage2 = b.dataset.url;
            b.classList.remove('active');
            b.src = srcImage2;
        });
        const index = $(".location-quad__slider .slick-current").data('slick-index');
        let srcNew = $('.location-quad__map--point .slick-position-'+index).data('hover');
        $('.location-quad__map--point .slick-position-'+index).attr('src',srcNew);
        $('.location-quad__map--point .slick-position-'+index).addClass('active');
    })

    $('.location-quad__map--point .slick-position-0').click();

    $('.text-modules-wrapper').addClass('animate-fade top');

    var data = document.URL;
    if(data.indexOf('#') != -1){
        data = data.split("#")[1]
        var top_ele = $("#" + data).offset().top;
        $('html,body').animate({scrollTop:top_ele-150},1500).delay(1200);
    }

    $('.js-open-menu').click(()=>{
        $('#menu-mobile').addClass('show');
    });

    $('.js-close-menu-mobile').click(()=>{
        $('#menu-mobile').removeClass('show');
    })

})();